<template>
    <div class="columns is-multiline d-flex flex-column flex-md-row pr-2 pl-2 sm:pl-0">
        <section class="sidebar column is-full-mobile is-4-tablet is-3-desktop">
            <cat-uxo-call-to-action class="mb-4 shape--top"></cat-uxo-call-to-action>
            <a class="btn w-100 mb-4" href="/contribute">Contribute a New Hazard</a>

            <div>
                <h4 class="mb-2 text-center">Download the CAT-UXO App </h4>
                <div class="app-download-buttons d-flex mb-4">
                    <a target="_blank" href="https://apps.apple.com/by/app/cat-uxo/id6720751417?platform=iphone">
                        <img src="/img/download-on-the-app-store.png" alt="" >
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.catuxo.mobile&hl=en">
                        <img src="/img/get-it-on-google-play.png" alt="" class="">
                    </a>
                </div>
            </div>

            <cat-uxo-stacked-ads></cat-uxo-stacked-ads>
        </section>
        <section class="uxo-type column is-offset-1-desktop is-8 p-0">
            <template v-if="!loading">
                <div class="flex w-full flex-col space-y-4">
                    <div class="flex flex-col space-y-1">
                        <h1 class="text-xl font-medium text-gray-800 font-medium capitalize">{{ title }}</h1>
                        <div class="text-sm text-[#E57722]">{{ meta.total }} results</div>
                    </div>
                    <div class="flex w-full">
                        <form id="searchForm" :action="`/explosive-hazards/${slug}`" class="form form-search flex flex-col justify-content-center w-full">
                            <div class="field position-relative w-100">
                                <div class="control">
                                    <input class="input w-100 rounded-xl" name="query" type="text" :value="query" placeholder="What are you looking for?"/>
                                </div>
                                <div class="control">
                                    <button class="btn btn-search !rounded-tr-xl !rounded-br-xl"></button>
                                </div>
                            </div>
                            <div v-if="!['terrorist-groups', 'incidents'].includes(this.slug)" class="flex flex-col">
                                <div class="flex flex-col sm:flex-row space-x-0 space-y-2 sm:space-y-0 sm:space-x-2 mt-1 sm:mt-2">
                                    <select class="input rounded-xl" onchange="this.form.submit()" name="category_id">
                                        <option selected disabled value="">Select a Category</option>
                                        <option v-for="filter in filters['categories']"
                                                :selected="parseInt(formParams['category_id']) === filter.id"
                                                :value="filter.id" :key="filter.id">{{ filter.name }}
                                        </option>
                                    </select>
                                    <select class="input rounded-xl" onchange="this.form.submit()" name="country_of_origin_id">
                                        <option selected disabled value="">Country of Origin</option>
                                        <option v-for="filter in filters['countries_of_origin']"
                                                :selected="parseInt(formParams['country_of_origin_id']) === filter.id"
                                                :value="filter.id" :key="filter.id">{{ filter.name }}
                                        </option>
                                    </select>
                                    <select class="input rounded-xl" onchange="this.form.submit()" name="country_used_in_id">
                                        <option selected disabled value="">Country Used In</option>
                                        <option v-for="filter in filters['countries_used_in']"
                                                :selected="parseInt(formParams['country_used_in_id']) === filter.id"
                                                :value="filter.id" :key="filter.id">{{ filter.name }}
                                        </option>
                                    </select>
                                </div>
                                <div class="flex flex-col sm:flex-row space-x-0 space-y-2 sm:space-y-0 sm:space-x-2 mt-1 sm:mt-2">
                                    <select class="input rounded-xl" onchange="this.form.submit()" name="diameter">
                                        <option selected disabled value="">Diameter</option>
                                        <option v-for="filter in filters['diameters']"
                                                :selected="parseInt(formParams['diameter']) === filter.id"
                                                :value="filter.id" :key="filter.id">{{ filter.name }}
                                        </option>
                                    </select>
                                    <select class="input rounded-xl" onchange="this.form.submit()" name="length">
                                        <option selected disabled value="">Length</option>
                                        <option v-for="filter in filters['lengths']"
                                                :selected="parseInt(formParams['length']) === filter.id"
                                                :value="filter.id" :key="filter.id">{{ filter.name }}
                                        </option>
                                    </select>
                                    <select class="input rounded-xl" onchange="this.form.submit()" name="height">
                                        <option selected disabled value="">Height</option>
                                        <option v-for="filter in filters['heights']"
                                                :selected="parseInt(formParams['height']) === filter.id"
                                                :value="filter.id" :key="filter.id">{{ filter.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div v-if="this.slug === 'terrorist-groups'" class="flex space-y-2 flex-col mt-1 sm:mt-2 ">
                                <div class="flex flex-col sm:flex-row space-x-0 space-y-2 sm:space-y-0 sm:space-x-2">
                                    <select class="input rounded-xl" onchange="this.form.submit()" name="status">
                                        <option selected disabled value="">Status</option>
                                        <option v-for="filter in filters['status']"
                                                :selected="formParams['status'] === filter.id"
                                                :value="filter.id" :key="filter.id">{{ filter.name }}
                                        </option>
                                    </select>
                                    <select class="input rounded-xl" onchange="this.form.submit()" name="country_of_origin_id">
                                        <option selected disabled value="">Country of Origin</option>
                                        <option v-for="filter in filters['countries_of_origin']"
                                                :selected="parseInt(formParams['country_of_origin_id']) === filter.id"
                                                :value="filter.id" :key="filter.id">{{ filter.name }}
                                        </option>
                                    </select>
                                </div>
                                <div class="flex flex-col sm:flex-row space-x-0 space-y-2 sm:space-y-0 sm:space-x-2">
                                    <select class="input rounded-xl" onchange="this.form.submit()" name="hazard_id">
                                        <option selected disabled value="">Associated Hazard</option>
                                        <option v-for="filter in filters['related_hazards']"
                                                :selected="parseInt(formParams['hazard_id']) === filter.id"
                                                :value="filter.id" :key="filter.id">{{ filter.name }}
                                        </option>
                                    </select>
                                    <select class="input rounded-xl" onchange="this.form.submit()" name="incident_id">
                                        <option selected disabled value="">Associated Incident</option>
                                        <option v-for="filter in filters['related_incidents']"
                                                :selected="parseInt(formParams['incident_id']) === filter.id"
                                                :value="filter.id" :key="filter.id">{{ filter.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div v-if="this.slug === 'incidents'" class="flex flex-col sm:flex-row space-x-0 space-y-2 sm:space-y-0 sm:space-x-2 mt-1 sm:mt-2 ">

                                <select class="input rounded-xl" onchange="this.form.submit()" name="hazard_id">
                                    <option selected disabled value="">Associated Hazard</option>
                                    <option v-for="filter in filters['related_hazards']"
                                            :selected="parseInt(formParams['hazard_id']) === filter.id"
                                            :value="filter.id" :key="filter.id">{{ filter.name }}
                                    </option>
                                </select>
                                <select class="input rounded-xl" onchange="this.form.submit()" name="terrorist_group_id">
                                    <option selected disabled value="">Associated Terrorist Group</option>
                                    <option v-for="filter in filters['terrorist_groups']"
                                            :selected="parseInt(formParams['terrorist_group_id']) === filter.id"
                                            :value="filter.id" :key="filter.id">{{ filter.name }}
                                    </option>
                                </select>
                            </div>

                            <div v-if="Object.keys(formParams).length" @click="clearFilters()"
                                 class="text-xs text-gray-600 my-auto cursor-pointer min-w-max mx-auto py-3 sm:py-0 sm:mx-4 sm:pl-3 flex space-x-2">
                                <div>Clear filters</div>
                                <svg class="w-4 my-auto fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                    <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                                    <path
                                        d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/>
                                </svg>
                            </div>

                        </form>
                    </div>


                    <template v-if="records">

                        <div v-if="records.length" class="flex cap flex-col border rounded-xl bg-white p-1">
                            <div class="bg-[#143642] p-1 px-2 w-full rounded-[9px] capitalize text-white text-sm font-medium">{{ title }}</div>
                            <div class="flex flex-col space-y-4 pt-4 p-2">
                                <template v-for="record in records">
                                    <div class="flex group w-full">
                                        <a :href="record.permalink" class="min-w-max relative">
                                            <img v-if="Object.prototype.hasOwnProperty.call(record, 'active')" class="aspect-video rounded-lg w-32 object-contain" :src="record.image"/>
                                            <img v-else class="w-32 h-32 object-contain" :src="record.image"/>
                                        </a>
                                        <div class="flex flex-col flex-grow px-3 space-y-1 my-auto min-w-0">
                                            <div v-if="Object.prototype.hasOwnProperty.call(record, 'active')">
                                                <div class="flex">
                                                    <div
                                                        :class="{
                                                        'bg-[#73788d]' : !record.active,
                                                        'bg-[#b71111]' : record.active
                                                    }"
                                                        class="px-1 py-0.5 rounded-lg text-white uppercase tracking-[1px] text-xs ">{{ record.active ? 'Active' : 'Inactive' }}
                                                    </div>
                                                </div>
                                            </div>
                                            <a :href="record.permalink" class="text-sm font-medium group-hover:text-[#E57722]">{{ record.name }}</a>
                                            <div class="!text-xs text-slate-800 line-clamp-4 description-preview" v-html="record.description_html"></div>
                                        </div>
                                        <a :href="record.permalink" class="min-w-max my-auto">
                                            <svg class="fill-current text-[#E57722] w-2.5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                                                <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                                                <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/>
                                            </svg>
                                        </a>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <div v-if="records.length" class="flex w-full max-w-full justify-between flex-wrap">

                            <a
                                v-if="meta.last_page > 1 && currentPage > 1"
                                :href="paginationLink(currentPage - 1)"
                                class="text-xs p-1"
                            >&larr; Previous</a>
                            <div v-else class="w-12"></div>

                            <div class="flex max-w-[70%] flex-wrap -ml-1">
                                <div v-for="(page, idx) in paginationRange" :key="idx">
                                    <template v-if="page === '...'">
                                        <span class="text-xs ml-1">...</span>
                                    </template>
                                    <template v-else>
                                        <a
                                            :href="paginationLink(page)"
                                            :class="{
              'text-[#E57722] font-medium': currentPage === page,
              'text-gray-600':        currentPage !== page
            }"
                                            class="text-xs flex aspect-square bg-white border rounded ml-1 mb-1"
                                        >
                                            <span class="w-7 text-center m-auto">{{ page }}</span>
                                        </a>
                                    </template>
                                </div>
                            </div>

                            <a
                                v-if="currentPage < meta.last_page"
                                :href="paginationLink(currentPage + 1)"
                                class="text-xs p-1"
                            >Next &rarr;</a>
                            <div v-else class="w-12"></div>

                        </div>

                    </template>


                    <div v-if="!records.length">
                        <div class="font-medium text-[#143642]">No results found matching your search query.</div>
                    </div>

                </div>
            </template>
            <template v-else>
                <div class="w-full h-full flex">
                    <div role="status" class="mx-auto flex flex-col mt-20">
                        <svg aria-hidden="true" class="inline mx-auto w-14 h-14 text-[#143642] animate-spin fill-[#E57722]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor"/>
                            <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentFill"/>
                        </svg>
                        <div class="font-medium text-[#143642] mt-4">Searching CAT-UXO database...</div>
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </template>
        </section>
    </div>
</template>

<script>
import StackedAds from "../shared/StackedAds";
import {axiosPlatform} from "@/js/axios";

export default {
    components: {
        StackedAds,
    },
    props: {
        slug: {
            type: String,
            required: true
        },

        title: {
            type: String,
            required: true
        },
    },
    data: function () {
        return {
            loading: true,
            records: null,
            meta: null,
            filters: null,
            query: '',
            page: 1
        }
    },
    computed: {
        pages() {
            return Array.from({length: this.meta.last_page}, (_, i) => i + 1);
        },
        urlParams() {
            const urlParams = new URLSearchParams(window.location.search)
            const params = {}
            for (const [key, value] of urlParams.entries()) {
                if (key !== 'page') params[key] = value;
            }
            return params
        },
        formParams() {
            const urlParams = new URLSearchParams(window.location.search)
            const params = {}
            for (const [key, value] of urlParams.entries()) {
                if (key !== 'page' && key !== 'query') params[key] = value;
            }
            return params
        },
        currentPage() {
            const urlParams = new URLSearchParams(window.location.search)
            return urlParams.get('page') ? parseInt(urlParams.get('page')) : 1
        },
        paginationRange() {
            const total = this.meta.last_page;
            const current = this.currentPage;
            const maxSlots = 14; // total “slots” including first, last, numbers, and ellipses

            // if total pages less than or equal maxSlots, just show all
            if (total <= maxSlots) {
                return Array.from({ length: total }, (_, i) => i + 1);
            }

            const range = [];
            const sideSlots = 2; // always keep first 1, last 1, plus these slots on each side of current
            const middleSlots = maxSlots - sideSlots * 2 - 2;
            // subtract first, last, and two for potential ellipses

            let start = Math.max(2, current - Math.floor(middleSlots / 2));
            let end   = Math.min(total - 1, current + Math.floor(middleSlots / 2));

            // if we're too close to beginning or end, shift
            if (current - 1 < Math.floor(middleSlots / 2)) {
                start = 2;
                end = start + middleSlots - 1;
            }
            if (total - current < Math.floor(middleSlots / 2)) {
                end = total - 1;
                start = end - middleSlots + 1;
            }

            // 1st page
            range.push(1);

            // left ellipsis
            if (start > 2) {
                range.push('...');
            }

            // middle pages
            for (let i = start; i <= end; i++) {
                range.push(i);
            }

            // right ellipsis
            if (end < total - 1) {
                range.push('...');
            }

            // last page
            range.push(total);

            return range;
        }
    },
    methods: {
        clearFilters() {

            const form = document.getElementById('searchForm');

            // Get all select elements inside the form
            const selects = form.querySelectorAll('select');

            // Clear each select
            selects.forEach(select => {
                select.selectedIndex = 0; // Resets to the first option
            });

            // Submit the form
            form.submit();


        },
        paginationLink(page) {
            const params = new URLSearchParams();
            Object.keys(this.urlParams).map((val) => {
                params.set(val, this.urlParams[val])
            })
            params.set('page', page)
            return `?${params.toString()}`
        }
    },
    async created() {

    },
    async mounted() {
        const queryString = window.location.search
        const urlParams = new URLSearchParams(queryString)
        urlParams.set('slug', this.slug)

        // Create a list of keys to delete
        const keysToDelete = [];
        for (const [key, value] of urlParams.entries()) {
            if (value === '') {
                keysToDelete.push(key);
            }
        }

        // Delete after collecting
        for (const key of keysToDelete) {
            urlParams.delete(key);
        }

        const records = (await axiosPlatform.get(`/${['terrorist-groups', 'incidents'].includes(this.slug) ? this.slug : 'hazards'}?${urlParams.toString()}`)).data

        this.query = urlParams.get('query')
        this.records = records.data
        this.meta = records.meta
        this.filters = records.filters
        this.loading = false
    }
}
</script>
<style scoped>

.description-preview >>> p,
.description-preview >>> * {
    font-size: 0.75rem;
    line-height: 1rem;
}

.description-preview >>> p {
    margin: 0;
}

.description-preview >>> a {
    color: #E57722;
    font-weight: 500;
}

.description-preview >>> a:hover {
    color: #985917;
}

select {
    background-image: linear-gradient(45deg, transparent 50%, black 50%),
    linear-gradient(135deg, black 50%, transparent 50%);
    background-position: right 24px top 50%, right 19px top 50%; /* 24px and 19px spacing */
    background-size: 5px 5px;
    background-repeat: no-repeat;
}

</style>



// WEBPACK FOOTER //
// resources/js/components/pages/PlatformHazardType.vue